.PlanDetails_PlanDetails_5c26a89{display:flex;flex-direction:column;align-items:center;row-gap:1em}